import React, { useEffect, useContext } from "react";
import {
  IonPage,
  IonCol,
  IonRow,
  IonTitle,
  IonSpinner,
} from "@ionic/react";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import "../theme/AppStyles.css";


const Splash: React.FC = () => {
  const history = useHistory();
  const { authReady } = useContext(AuthContext);

  useEffect(() => {
    if (!authReady) return;

    // Auth is ready — brief delay for splash branding, then navigate
    const timer = setTimeout(() => {
      history.push('./home');
    }, 1000);

    return () => clearTimeout(timer);
  }, [authReady, history]);
  
  return (
    <IonPage className="bckgrnd">
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow>
            <IonCol></IonCol>
        </IonRow>
        <IonRow>
          <IonCol size="">
            <IonTitle className="splashTxt">WerkApp</IonTitle>
          </IonCol>
        </IonRow>
          <IonRow>
            <IonCol className="title2">
              <IonSpinner className="backArrowColor" name="dots">
            </IonSpinner>
          </IonCol>
        </IonRow>  
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
    </IonPage>
  );
};

export default Splash;
